import { Application, Container } from "pixi.js";
import { Fish, fish, FishDefinition } from "./fish";

export const AIFish = async (
  num: number,
  app: Application,
  fishList: (FishDefinition & { school: SchoolAttributes })[],
) => {
  const container = new Container();
  for (let i = 0; i < num; i++) {
    const fishDef = fishList[Math.floor(fishList.length * Math.random())];
    if (fishDef.attributes.rarity > Math.random()) {
      i--;
      continue;
    }
    container.addChild(
      await school(
        app,
        fishDef,
        Math.random() * 6000 - 3000,
        Math.random() * 6000 - 3000,
      ),
    );
  }
  return container;
};

export type SchoolAttributes = {
  spread: number;
  minSize: number;
  maxSize: number;
  tick: (f: Fish[]) => void;
};

const randomPlusMinus = () => {
  const x = Math.random() * Math.random();
  if (Math.random() < 0.5) {
    return x;
  } else {
    return -x;
  }
};

const school = async (
  app: Application,
  fishDef: FishDefinition & {
    school: SchoolAttributes;
  },
  x: number,
  y: number,
) => {
  const fishes: Fish[] = [];
  const container = new Container();

  const count =
    fishDef.school.minSize +
    Math.random() * (fishDef.school.maxSize - fishDef.school.minSize);

  for (let i = 0; i < count; i++) {
    const f = await fish(app, fishDef);

    f.sprite.x = x + randomPlusMinus() * fishDef.school.spread;
    f.sprite.y = y + randomPlusMinus() * fishDef.school.spread;

    container.addChild(f.sprite);
    fishes.push(f);
  }

  for (let i = 0; i < 10; i++) {
    fishDef.school.tick(fishes);
  }

  setInterval(
    () => {
      fishDef.school.tick(fishes);
      fishes.forEach((f) => {
        setTimeout(() => {
          f.dx += Math.pow(randomPlusMinus(), 2);
          f.dy += Math.pow(randomPlusMinus(), 2);
        }, Math.random() * 1000);
      });
    },
    1000 + 1000 * Math.random(),
  );

  return container;
};
